import { useState } from 'react';
import "./Projects.css";

const Projects = () => {
    const [data] = useState([
        { id: 1, projectName: 'Peer-to-Peer Note Sharing', summary: 'A portal for students to share their notes with each other', tech: ['Angular', 'Firebase'], image: '/images/note-sharing.png' },
        { id: 2, projectName: 'Circle Sheets', summary: 'Digitized circle sheets for Steelcase shipping department', tech: ['React Native', 'Expo'], image: '/images/circlesheets.png' },
        { id: 3, projectName: 'Piggy Bank', summary: 'A financial literacy tool for kids', tech: ['Vue.js', 'Firebase', 'Google Home'], image: '/images/piggybank.png' },
        { id: 4, projectName: 'Spookies', summary: 'A shared horror movie tracker for friends to log and rate movies', tech: ['React Native', 'Firebase'], image: '/images/spookies.png' },
    ]);

    return (
        <div className="projects-container">
            <div className="projects-header">
                <span className="projects-eyebrow">Work</span>
                <h2 className="projects-title">Projects</h2>
                <p className="projects-subtitle">Things I've built along the way</p>
            </div>

            <div className="projects-grid">
                {data.map(item => (
                    <article key={item.id} className="project-card">
                        <div className="project-image-wrap">
                            <img
                                src={item.image}
                                alt={item.projectName}
                                className="project-image"
                            />
                        </div>
                        <div className="project-body">
                            <h3 className="project-name">{item.projectName}</h3>
                            <p className="project-summary">{item.summary}</p>
                            <div className="project-tags">
                                {item.tech.map((t, i) => (
                                    <span key={i} className="project-tag">{t}</span>
                                ))}
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default Projects;